import type { WorldMeta } from "../registry";

export const meta: WorldMeta = {
  id: "FW-30",
  name: "Meridian Yard",
  slug: "meridian-yard",
  title: "Meridian Yard — a Fable World: architecture storefront",
  description:
    "An original architecture storefront designed by Fable: peeling listing cards over a particle field of survey stakes that fences what you hold."
};

export default meta;
